import { ConfigProvider } from "antd";
import { ICON_PREFIX, CMP_PREFIX } from "@/base/constant";
import {
  ThemeCSOStylesProvider,
  ThemeCSOStylesProviderProps,
} from "./theme-cso-styles";
import { GlobalFont } from "@/base/global/styles/font.styles";
import { GlobalBody } from "@/base/global/styles/body.styles";
import { GlobalScroll } from "@/base/global/styles/scroll.styles";
import * as tokens from "@/base/components/tokens";
import { globalThemeTokens as global } from "@/base/global/theme-tokens";

export interface ThemeCSOProviderProps extends ThemeCSOStylesProviderProps {
  children: React.ReactNode | React.ReactNode[];
}

export const ThemeCSOProvider = ({
  children,
  ...props
}: ThemeCSOProviderProps) => {
  const { ...components } = tokens;
  const themeTokens: any = {
    token: { ...global },
    components: { ...components },
  };

  return (
    <ConfigProvider
      prefixCls={CMP_PREFIX}
      iconPrefixCls={ICON_PREFIX}
      theme={themeTokens}
    >
      <GlobalFont />
      <GlobalBody />
      <GlobalScroll />
      <ThemeCSOStylesProvider {...props}>{children}</ThemeCSOStylesProvider>
    </ConfigProvider>
  );
};
